import React from 'react'

const KeyIcon: React.FC<{ className: string }> = ({ className }) => (
  <svg
    className={className}
    width="31.5"
    height="31.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 2C12.567 2 11 3.567 11 5.5C11 7.433 12.567 9 14.5 9C16.433 9 18 7.433 18 5.5C18 3.567 16.433 2 14.5 2ZM9 5.5C9 2.46243 11.4624 0 14.5 0C17.5376 0 20 2.46243 20 5.5C20 8.53757 17.5376 11 14.5 11C13.3425 11 12.2685 10.6424 11.3825 10.0317L7.91421 13.5L9.7071 15.2929C10.0976 15.6834 10.0976 16.3166 9.7071 16.7071C9.31658 17.0976 8.68341 17.0976 8.29289 16.7071L6.5 14.9142L4.91421 16.5L6.7071 18.2929C7.09763 18.6834 7.09763 19.3166 6.7071 19.7071C6.31658 20.0976 5.68341 20.0976 5.29289 19.7071L3.5 17.9142L1.7071 19.7071C1.31658 20.0976 0.683413 20.0976 0.292889 19.7071C-0.0976354 19.3166 -0.0976357 18.6834 0.292889 18.2929L2.79233 15.7935L2.79289 15.7929L2.79345 15.7923L9.96826 8.61752C9.35756 7.73148 9 6.6575 9 5.5ZM13.6241 6.38388C14.1123 6.87204 14.9037 6.87204 15.3919 6.38388C15.88 5.89573 15.88 5.10427 15.3919 4.61612C14.9037 4.12796 14.1123 4.12796 13.6241 4.61612C13.136 5.10427 13.136 5.89573 13.6241 6.38388Z"
    />
  </svg>
)

export default KeyIcon
